var _excluded = ["name", "onChange", "selectedValue", "small", "full", "children", "style"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { string, func, oneOfType, number, bool, node, shape } from 'prop-types';
import styled from 'styled-components';
import RadioGroupContext from '../RadioGroupContext';
var Group = styled.div.attrs({
  role: 'radiogroup'
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  width: min-content;\n\n  ", "\n"])), function (_ref) {
  var full = _ref.full;
  return "\n    " + (full ? "width: 100%;" : "") + "\n  ";
});

var RadioGroup = function RadioGroup(_ref2) {
  var name = _ref2.name,
      onChange = _ref2.onChange,
      selectedValue = _ref2.selectedValue,
      small = _ref2.small,
      full = _ref2.full,
      children = _ref2.children,
      style = _ref2.style,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: _extends({
      selectedValue: selectedValue,
      name: name,
      onChange: onChange,
      small: small
    }, rest)
  }, /*#__PURE__*/React.createElement(Group, _extends({
    full: full,
    style: style
  }, rest), children));
};

RadioGroup.propTypes = {
  name: string,
  onChange: func,
  selectedValue: oneOfType([string, number]),
  small: bool,
  full: bool,
  children: node,
  style: shape({})
};
RadioGroup.defaultProps = {
  name: '',
  onChange: function onChange() {},
  selectedValue: '',
  small: false,
  full: false,
  children: null,
  style: {}
};
export default RadioGroup;